import './_animations';
import './_fontawesome';
import '@fancyapps/fancybox';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

Alpine.plugin(collapse);
Alpine.start();

window.addEventListener('load', function() {
    /**
     * Scrolling behaviour
     */
    let changeScrollDirection = false;
    let scrollChildElement;
    const childElementStallDistance = 500;
    let childElementCurrentStallDistance = 0;
    const scrollContainer = document.querySelector('main');

    scrollContainer.addEventListener('wheel', (evt) => {
        if (changeScrollDirection && !scrollChildElement) {
            evt.preventDefault();
            scrollContainer.scrollLeft += evt.deltaY;
        } else if(changeScrollDirection && scrollChildElement) {
            evt.preventDefault();

            childElementCurrentStallDistance += Math.abs(evt.deltaY);

            if (childElementCurrentStallDistance < childElementStallDistance) {
                return;
            }

            scrollChildElement.scrollTop += evt.deltaY;

            if (evt.deltaY < 0 && scrollChildElement.scrollTop === 0) {
                scrollChildElement = null;
                childElementCurrentStallDistance = 0;
            } else if (evt.deltaY > 0 && scrollChildElement.scrollHeight - scrollChildElement.scrollTop <= scrollChildElement.clientHeight) {
                scrollChildElement = null;
                childElementCurrentStallDistance = 0;
            }
        }
    });

    window.addEventListener('resize', (event) => {
        changeScrollDirection = window.innerWidth >= 1024;
    });

    window.dispatchEvent(new Event('resize'));

    if(window.location.hash) {
        const scrollToSection = document.querySelector('section' + window.location.hash);
        if (scrollToSection && changeScrollDirection) {
            scrollContainer.scrollLeft = scrollToSection.offsetLeft;
        }
    }

    const sections = document.querySelectorAll('main > section');
    const sectionObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                history.pushState({}, "", "#" + entry.target.id);
            }
        });
    }, {rootMargin: '0px', threshold: 0.5});
    sections.forEach(section => sectionObserver.observe(section));

    /**
     * Snap on scroll
     */
    const scrollChildren = document.querySelectorAll('.snap-on-scroll');
    const scrollChildrenObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                scrollChildElement = entry.target;
            }
        });
    }, {rootMargin: '0px', threshold: 1.0, root: document.querySelector('body')});
    scrollChildren.forEach(child => scrollChildrenObserver.observe(child));
});
